// extracted by mini-css-extract-plugin
export default {"modal":"ModalSmall_modal__3H4y5","modal-content":"ModalSmall_modal-content__vpp1a","close-modal":"ModalSmall_close-modal__Kec3c"};